<div class="card border-0 shadow-sm mb-4">
  <div class="card-header bg-primary bg-gradient text-white d-flex justify-content-between align-items-center">
    <h4 class="card-title mb-0">
      <i class="fa fa-cog me-2"></i>
      General Settings
    </h4>
    
    <!-- Edit/Cancel Button -->
    <div class="d-flex gap-2">
      <button 
        type="button" 
        class="btn btn-outline-light btn-sm"
        (click)="toggleEditMode()"
        [disabled]="isLoading || isSaving">
        <i class="fa" 
           [class.fa-edit]="!isEditMode"
           [class.fa-times]="isEditMode"
           class="me-1"></i>
        {{ isEditMode ? 'Cancel' : 'Edit' }}
      </button>
    </div>
  </div>
  
  <div class="card-body">
    
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 text-muted">Loading settings...</p>
    </div>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
      <i class="fa fa-check-circle me-2"></i>
      {{ successMessage }}
      <button type="button" class="btn-close" (click)="successMessage = ''"></button>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
      <i class="fa fa-exclamation-triangle me-2"></i>
      {{ errorMessage }}
      <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
    </div>

    <!-- Form -->
    <form [formGroup]="generalForm" (ngSubmit)="onSubmit()" *ngIf="!isLoading" class="row g-3">
      
      <!-- Application Name -->
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Application Name</label>
        <input 
          type="text" 
          class="form-control"
          [class.is-invalid]="hasError('applicationName', 'required') || hasError('applicationName', 'minlength')"
          formControlName="applicationName"
          placeholder="Enter application name">
        
        <div class="invalid-feedback">
          <div *ngIf="hasError('applicationName', 'required')">Application name is required.</div>
          <div *ngIf="hasError('applicationName', 'minlength')">Application name must be at least 3 characters long.</div>
        </div>
      </div>

      <!-- Default Language -->
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Default Language</label>
        <select 
          class="form-select"
          [class.is-invalid]="hasError('defaultLanguage', 'required')"
          formControlName="defaultLanguage">
          <option value="">Select a language</option>
          <option value="en">English</option>
          <option value="es">Spanish</option>
        </select>
        
        <div class="invalid-feedback">
          <div *ngIf="hasError('defaultLanguage', 'required')">Please select a default language.</div>
        </div>
      </div>

      <!-- Application Description -->
      <div class="col-12">
        <label class="form-label fw-semibold">Application Description</label>
        <textarea 
          class="form-control" 
          rows="3"
          [class.is-invalid]="hasError('applicationDescription', 'required') || hasError('applicationDescription', 'minlength')"
          formControlName="applicationDescription"
          placeholder="Enter application description"></textarea>
        
        <div class="invalid-feedback">
          <div *ngIf="hasError('applicationDescription', 'required')">Application description is required.</div>
          <div *ngIf="hasError('applicationDescription', 'minlength')">Description must be at least 10 characters long.</div>
        </div>
      </div>
      
      <!-- Application Control Section -->
      <div class="col-12">
        <h6 class="fw-semibold text-secondary mt-3 mb-2">
          <i class="fa fa-toggle-on me-2"></i>
          Application Control
        </h6>
      </div>
      
      <!-- Restrict User Registration Toggle -->
      <div class="col-12 col-md-6">
        <div class="form-check form-switch">
          <input 
            class="form-check-input" 
            type="checkbox" 
            id="restrictRegistration"
            formControlName="restrictUserRegistration">
          <label class="form-check-label fw-semibold" for="restrictRegistration">
            <i class="fa fa-user-lock me-2 text-warning"></i>
            Restrict User Registration
          </label>
          <div class="form-text">
            When enabled, new users cannot register for the application
          </div>
        </div>
      </div>
      
      <!-- Maintenance Mode Toggle -->
      <div class="col-12 col-md-6">
        <div class="form-check form-switch">
          <input 
            class="form-check-input" 
            type="checkbox" 
            id="maintenanceMode"
            formControlName="maintenanceMode">
          <label class="form-check-label fw-semibold" for="maintenanceMode">
            <i class="fa fa-tools me-2 text-danger"></i>
            Maintenance Mode
          </label>
          <div class="form-text">
            When enabled, the application will be in maintenance mode
          </div>
        </div>
      </div>
      
      <!-- Submit Button - Only show in edit mode -->
      <div class="col-12" *ngIf="isEditMode">
        <button 
          type="submit" 
          class="btn btn-primary"
          [disabled]="isSaving || generalForm.invalid">
          <i class="fa" 
             [class.fa-save]="!isSaving"
             [class.fa-spinner]="isSaving"
             [class.fa-spin]="isSaving"
             class="me-1"></i>
          {{ isSaving ? 'Saving...' : 'Save Changes' }}
        </button>
        
        <button 
          type="button" 
          class="btn btn-outline-secondary ms-2"
          (click)="resetForm()"
          [disabled]="isSaving || isLoading">
          <i class="fa fa-undo me-1"></i>
          Reset
        </button>
      </div>
    </form>
  </div>
</div>